import { ReactNode } from "react";
import { GetProfileQueryQuery } from "types/graphql-schema";

import { currentOrganizationVar } from "@cache/cache";

import ProfileItems from "./profile-items";

export type ProfileContentTab = {
  value: string;
  label: string;
  available: boolean;
  render: () => ReactNode;
};

// The profile "content" tabs. Goals, recognitions, feedback and action items
// are combined into a single "Items" tab (with its own sub-tabs); reviews now
// live at the top of the Career tab. Centralizes which sections exist (org
// feature flags) and how to render each, so profile-page.tsx can build both
// the tab buttons and their routes from one source of truth.
const useProfileContentTabs = (
  profile: GetProfileQueryQuery["user"] | undefined,
): ProfileContentTab[] => {
  const organization = currentOrganizationVar();

  if (!profile) return [];

  const hasAnyItemType = !!(
    organization.featureFlags.actionItems ||
    organization.featureFlags.goals ||
    organization.featureFlags.feedbacks ||
    organization.featureFlags.recognitions
  );

  return [
    {
      value: "items",
      label: "Items",
      available: hasAnyItemType,
      render: () => <ProfileItems profile={profile} />,
    },
  ];
};

export default useProfileContentTabs;
